import { ready, slide } from './utils';

const faq = {
	init: () => ready(() => {
		const headings = document.querySelectorAll('.js-faqItem .accordion-heading')
		
		const onClick = (e) => {
			slide({
				e,
				parentSelector: '.js-faqItem',
				contentSelector: '.accordion-content',
			})
		}

		for (let i = 0; i < headings.length; i++) {
			headings[i].addEventListener('click', onClick)
		}
	})
}

export default faq